import React, { FC } from 'react';
import { useEnvironment, useTranslation } from '@wix/yoshi-flow-editor';
import { Dialog } from 'wix-ui-tpa/Dialog';
import { Text, TYPOGRAPHY } from 'wix-ui-tpa/Text';
import { Button, PRIORITY } from 'wix-ui-tpa/Button';

import { classes, st } from './DiscardChangesModal.st.css';
import { DataHook } from '../../../../../constants/DataHook';
import { ModalType, BiActionType } from '../../../../../types';
import { useBi } from '../../../../../hooks/useBi';

type Props = {
  onConfirm(): void;
};

export const DiscardChangesModal: FC<ModalType<Props>> = ({
  onClose,
  isOpen,
  additionalProps,
}) => {
  const { t } = useTranslation();
  const { isMobile } = useEnvironment();
  const biLogger = useBi();

  const handleConfirm = () => {
    additionalProps.onConfirm();
    biLogger.ctaButtonClicked(BiActionType.Discard_Changes);
    onClose();
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      notFullscreenOnMobile
      className={st(classes.root, { mobile: isMobile })}
      data-hook={DataHook.DiscardChangesModal}
    >
      <div className={classes.content}>
        <Text typography={TYPOGRAPHY.largeTitle}>
          {t('app.widget.modals.discard-changes.title')}
        </Text>
        <Text
          typography={TYPOGRAPHY.listText}
          className={classes.textContainer}
          tagName="div"
        >
          {t('app.widget.modals.discard-changes.content')}
        </Text>
        <div className={classes.ctaContainer}>
          <Button
            upgrade
            priority={PRIORITY.basicSecondary}
            className={st(classes.button, { secondary: true })}
            onClick={onClose}
          >
            {t('app.widget.modals.discard-changes.primary-action')}
          </Button>
          <Button
            upgrade
            className={st(classes.button, { primary: true })}
            onClick={handleConfirm}
          >
            {t('app.widget.modals.discard-changes.secondary-action')}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};
